module.exports = __webpack_public_path__ + "static/img/product-top-6.3ccb5cb0.png";